export default __webpack_public_path__ + "static/media/user_activity_14_1.fb1df57f.svg";